// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3Js3J","header__logo":"header_header__logo__2PtZP","header__burgerMenu":"header_header__burgerMenu__3Ik8J","headerCabinet":"header_headerCabinet__3v04z"};